type ModalTitle = string | React.ReactElement;

type ModalProps = {
  id: string;
  title: ModalTitle;
  ref?: React.RefObject<HTMLDivElement>;
  onClose?: () => void;
};

const Modal = (props: React.PropsWithChildren<ModalProps>) => {
  const { id, title, children, onClose, ref } = props;

  return (
    <div className="modal fade" id={id} ref={ref}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            {typeof title === "string" ? (
              <h5 className="modal-title">{title}</h5>
            ) : (
              <div className="text-center w-100">{title}</div>
            )}
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
